/** Mi perfil en solo lectura: nombre, correo y empresa activa (design.md §22.7). */
import { useNavigate } from 'react-router-dom';
import { MobileLayout } from '@/components/MobileLayout';
import { MobileButton } from '@/components/MobileButton';
import { MobileIcon } from '@/components/MobileIcon';
import { SectionCard } from '@/components/SectionCard';
import { useMobileAuth } from '@/state/MobileAuthContext';

function DataRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="border-b border-border-light py-2.5 last:border-0 last:pb-0 first:pt-0">
      <p className="text-xs font-medium uppercase tracking-wide text-text-tertiary">{label}</p>
      <p className="mt-0.5 break-words text-sm font-medium text-text-primary">{value}</p>
    </div>
  );
}

export function ProfilePage() {
  const navigate = useNavigate();
  const { user, tenantName } = useMobileAuth();
  const fullName = user?.full_name?.trim() || '—';
  const email = user?.email?.trim() || '—';
  const company = tenantName ?? '—';

  return (
    <MobileLayout title="Mi perfil" subtitle="Datos de tu cuenta" showBack>
      <div className="space-y-3">
        <SectionCard title="Tus datos">
          <DataRow label="Nombre" value={fullName} />
          <DataRow label="Correo" value={email} />
          <DataRow label="Empresa activa" value={company} />
        </SectionCard>

        <SectionCard title="Cuenta" subtitle="Acceso a la aplicación">
          <MobileButton
            type="button"
            variant="primary"
            size="lg"
            fullWidth
            onClick={() => navigate('/m/password')}
            icon={<MobileIcon name="lock" className="h-5 w-5" />}
          >
            Cambiar contraseña
          </MobileButton>
        </SectionCard>
      </div>
    </MobileLayout>
  );
}
